import React from 'react'
import QRCode from 'qrcode.react'
interface Props {
  userNameValue: string
}

export const QRcode: React.SFC<Props> = ({ userNameValue }): JSX.Element => (
  <QRCode value={userNameValue} size={190} level={'H'} includeMargin={true} />
)
